@if(showContent()) {
  <div class="layout-container" style="height: 100vh; overflow: hidden">
    <div class="min-h-screen flex relative xl:static surface-ground">
      <app-navigation></app-navigation>
      <div class="layout-inner-container min-h-screen flex flex-column flex-auto z-0" style="overflow: hidden">
        <app-header></app-header>
        <div class="content p-3 md:p-5 mt-6 xl:mt-0 overflow-y-auto overflow-x-hidden" style="flex: 1 1 0; min-height: 0">
          <router-outlet></router-outlet>
        </div>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
} @else {
  <router-outlet></router-outlet>
}
